import React, { Fragment } from 'react';
import Yup from 'yup';

const completeTaskSchema = Yup.object().shape({
  hoursOfWork: Yup
    .number()
    .positive()
    .moreThan(0, "Must be greater than zero")
    .required("Hours field is requried")
});

const sectionStyle = { padding: 0 };
const titleStyle = { textAlign: "left" };

class CompleteTaskForm extends React.Component {

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.state = {
      error: "",
      values: {
        hoursOfWork: 0
      }
    };
  }

  handleInputChange(event) {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      values: {
        [name]: value
      }
    });
  }

  handleCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleSubmit(event) {

    completeTaskSchema
      .validate(this.state.values)
      .then(() => {
        if (this.props.onSubmit) {
          const task = { id: this.props.task.id, ...this.state.values };
          Promise.resolve(this.props.onSubmit(task))
            .catch(() => this.setState({ error: "Error processing the request" }));
        }
      })
      .catch(err => this.setState({ error: err.message }));

    event.preventDefault();
  }

  render() {
    return (
      <Fragment>
        <section className="edit-page" style={sectionStyle}>
          <h1 style={titleStyle}>Complete task</h1>
          <form onSubmit={this.handleSubmit}>
            <fieldset>
              <label className="title">Hours of work:</label>
              <div className="right">
                <input
                  name="hoursOfWork"
                  type="number"
                  value={this.state.values.hoursOfWork}
                  onChange={this.handleInputChange} />
              </div>
            </fieldset>
            <span>{this.state.error}</span><br />
            <button type="submit">Complete</button>
            <button type="button" onClick={this.handleCancel}>Cancel</button>
          </form>
        </section>
      </Fragment>
    );
  }
}

export default CompleteTaskForm;



// WEBPACK FOOTER //
// ./src/components/projects/Tasks/CompleteTaskForm.js